// CSS vendor
import "./vendor.css";

// polifyll
import "es6-promise/auto";

require("@gpittarelli/picturefill");
require("matchmedia-polyfill/matchMedia");
require("matchmedia-polyfill/matchMedia.addListener");

require(["lightgallery.js"], function () {
  require(["lg-thumbnail.js", "lg-fullscreen.js", "lg-zoom.js", "lg-share.js"]);
});
